import { IProgressGPTChatModel } from 'api/models';
import { getProgressGPTChats } from 'api/services';
import produce from 'immer';
import useDataQuery from 'modules/shared/hooks/useDataQuery';
import { useCallback } from 'react';

const useProgressGPTChatListData = () => {
    const progressGPTChatsQuery = useDataQuery(['progressGPTChats'], () => getProgressGPTChats());

    const addChat = useCallback(
        (chat: IProgressGPTChatModel) => {
            return progressGPTChatsQuery.setData((prevList) => {
                return produce(prevList, (draftState) => {
                    const alreadyExists = draftState.find((row) => row._id === chat._id);
                    if (!alreadyExists) {
                        draftState.unshift(chat);
                    }
                });
            });
        },
        [progressGPTChatsQuery]
    );

    const deleteChat = useCallback(
        (chatId: string) => {
            return progressGPTChatsQuery.setData((prevData) => {
                return produce(prevData, (draftState) => {
                    const index = draftState.findIndex((row) => row._id === chatId);

                    if (index !== -1) {
                        draftState.splice(index, 1);
                    }

                    return draftState;
                });
            });
        },
        [progressGPTChatsQuery]
    );

    return {
        isLoading: progressGPTChatsQuery.isLoading,
        chats: progressGPTChatsQuery.data,
        addChat,
        deleteChat,
    };
};

export default useProgressGPTChatListData;
